export default __webpack_public_path__ + "fd7691e.png";